<template>
    <div :class="cssClass">
        <div class="vehicle-teaser teaser" @click="handleModal">
            <p class="promotion-label electric mb-0" v-if="isElectric">
                <aut-icon-ev fill="currentColor"/>
                EV
            </p>
            <p class="promotion-label highlighted mb-0" :class="highlightedClass" v-if="item.highlighted">
                <span v-if="item.highlighted_text">
                    {{ item.highlighted_text }}
                </span>
                <span v-if="!item.highlighted_text" v-html="translations.highlightedText"></span>
            </p>
            <div class="image">
                <img
                    v-if="hasImage"
                    :src="item.images[0]" :alt="item.title">
            </div>

            <div class="title">
                <h3 v-if="item.title" class="virtual-h3 color-text">{{ item.title }}
                    <button class="information-button d-inline-block">{{ translations.moreInformation }}</button>
                </h3>

                <p class="subtitle mb-0" v-if="item.subtitle">{{ item.subtitle }}</p>


                <Badges
                    v-if="showBadges"
                    :badges="[
                        ...item.fuel_types,
                        ...item.transmission_types,
                        ...item.body_work_types,
                    ]"/>
            </div>

            <div class="mt-auto">
                <div class="price-wrapper row" v-if="!item.isCorporate">
                    <p class="price price-per-day col mb-0" v-if="prices.per_day && !item.show_week_prices">
                        <span class="label d-block font-weight-bold">
                            Dag
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(prices.per_day)"></span>
                    </p>

                    <p class="price price-per-weekend col mb-0" v-if="prices.per_weekend && !item.show_week_prices">
                        <span class="label d-block font-weight-bold">
                            Weekend
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(prices.per_weekend)"></span>
                    </p>


                    <p class="price price-per-week col mb-0" v-if="prices.per_week" :class="{
                        'show-week-prices': item.show_week_prices,
                    }">
                        <span class="label d-block font-weight-bold">
                            1 week
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(prices.per_week)"></span>
                    </p>


                    <p class="price price-per-2-weeks col mb-0" v-if="prices.per_2_weeks && item.show_week_prices">
                        <span class="label d-block font-weight-bold">
                            2 weken
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(prices.per_2_weeks)"></span>
                    </p>


                    <p class="price price-per-3-weeks col mb-0" v-if="prices.per_3_weeks && item.show_week_prices">
                        <span class="label d-block font-weight-bold">
                            3 weken
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(prices.per_3_weeks)"></span>
                    </p>


                    <div class="price has-discount" v-if="hasDiscountPrice">
                        <span>Van</span> {{ prices.per_day | currencyFormatter }}
                    </div>

                    <div class="discount-price font-weight-bold" v-if="hasDiscountPrice">
                        Voor {{ prices.discount_price | currencyFormatter }}
                        <small>per dag</small>
                    </div>
                </div>

                <div class="price-wrapper corporate-prices row" v-if="item.isCorporate">
                    <p class="price col mb-0">
                        <span class="label d-block font-weight-bold">
                            1 tot 3 dagen
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(34)"></span>
                    </p>

                    <p class="price col mb-0">
                        <span class="label d-block font-weight-bold">
                            4+ dagen
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(31)"></span>
                    </p>

                    <span class="col-12">
                        <hr>
                    </span>

                    <p class="price col mb-0">
                        <span class="label d-block font-weight-bold">
                            7+ dagen
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(28)"></span>
                    </p>

                    <p class="price col mb-0">
                        <span class="label d-block font-weight-bold">
                            14+ dagen
                        </span>

                        <span class="price-amount" v-html="generatePriceMarkup(26)"></span>
                    </p>
                </div>

                <button @click.stop="handleClickRentVehicle(iframe)" class="btn-primary mt-4 m-0 w-100">
                    {{ translations.rentDirectly }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import CurrencyFormatter from "../../mixins/CurrencyFormatter";
import translations from "../../mixins/translations";
import analytics from "../../mixins/analytics";
import vehicle from "../../mixins/vehicle";
import Badge from "../Content/Badge.vue";
import Badges from "./Badges.vue";
import {isEmpty} from "lodash";

export default {
    name: "Teaser",
    components: {Badges, Badge},

    mixins: [CurrencyFormatter, translations, analytics, vehicle],

    props: {
        id: {
            type: Number,
            required: true,
        },
        vehicleData: {
            type: Object,
            default: () => {
            }
        },
        isBusiness: {
            type: Boolean,
            default: false,
        },
        vatPercentage: {
            type: Number,
            required: false,
        },
        iframe: {
            type: Boolean,
            default: false,
        },
        isWrapper: {
            type: Boolean,
            default: false,
        }
    },

    data() {
        return {
            item: {},
            vat: 0,
            cssClass: "vue-vehicle-teaser",
        }
    },

    computed: {
        hasVehicleDataProp() {
            return !lodash.isEmpty(this.vehicleData);
        },

        isElectric() {
            return !isEmpty(this.item.fuel) && this.item.fuel.id === 'electric';
        },

        prices() {
            return {
                per_day: this.calculatePrice(this.item.price_per_day, this.vat),
                per_weekend: this.calculatePrice(this.item.price_per_weekend, this.vat),
                per_week: this.calculatePrice(this.item.price_per_week, this.vat),
                per_2_weeks: this.calculatePrice(this.item.price_per_2_weeks, this.vat),
                per_3_weeks: this.calculatePrice(this.item.price_per_3_weeks, this.vat),
                discount_price: this.calculatePrice(this.item.discount_price, this.vat),
            };
        },

        showBadges() {
            return !isEmpty(this.item.fuel_types) || !isEmpty(this.item.transmission_types) || !isEmpty(this.item.body_work_types);
        },

        highlightedClass() {
            return this.item.highlighted_color ? `bg-${this.item.highlighted_color}` : '';
        }
    },

    created() {
        this.fetchData();
    },

    methods: {
        fetchData() {
            this.vat = this.vatPercentage;
            if (lodash.isEmpty(this.vatPercentage)) {
                this.vat = drupalSettings.vat_percentage;
            }

            if (this.hasVehicleDataProp) {
                this.item = this.vehicleData;
                this.cssClass += " vue-item-id-" + this.item.id;
                return;
            }

            let url = `/api/vehicle-details?vehicleId=${this.id}`;

            if (this.isWrapper) {
                url = `/api/vehicle-wrapper-details?vehicleWrapperId=${this.id}`;
            }

            axios.get(url)
                .then(response => {
                    this.item = response.data;
                })
                .catch(error => {
                    this.item = {};
                });
        },

        calculatePrice(price, vatPercentage) {
            return (this.isBusiness === true) ? (price / (1 + (vatPercentage / 100))).toFixed(2) : price;
        },

        generatePriceMarkup(price) {
            if (isNaN(price) || price === null || price === undefined) {
                return price;
            } else if (Number.isInteger(price)) {
                return price + ",-";
            }

            const priceParts = price.toString().split(".");
            return `${priceParts[0]},<sup>${priceParts[1]}</sup>`;
        }
    }
}
</script>
